import scope from "./scope";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});
export const CLEAR_PIVOT_VALUES = `${scope}/CLEAR_PIVOT_VALUES`;
export const clearPivotValues = () => ({ type: CLEAR_PIVOT_VALUES });
